import {
  Flex,
  FormControl,
  FormErrorMessage,
  FormLabel,
  Input,
  Switch,
} from '@chakra-ui/react';
import { ErrorMessage } from '@hookform/error-message';
import { SnapSiteConfigEditFormDataUnvalidated } from '@snap-types/models/snap-site-config';
import { objectEntriesTyped } from '@snap-types/util/object-iterators';
import { Heading } from '@ui/components/layout/Heading';
import {
  PART_SEARCH_COLUMNS_CUSTOM_NAMES,
  PART_SEARCH_COLUMNS_FIXED_NAMES,
} from '@ui/features/quote-builder/components/PartDetailedSearch/PartDetailedSearchColumnChooserMenu';
import { useFormContext } from 'react-hook-form';

import { FeatureVisibleSelect } from './components/FeatureVisibleSelect';

export const PartSearchPanel = () => {
  const form = useFormContext<SnapSiteConfigEditFormDataUnvalidated>();

  return (
    <Flex direction="column" gap={4}>
      <FormControl>
        <Flex gap={1} flexDirection="column" alignItems="start">
          <FormLabel htmlFor={`partSearchVisible`}>
            Enable Detailed Part Search
          </FormLabel>
          <FeatureVisibleSelect
            {...form.register(`partSearchVisible`)}
            id={`partSearchVisible`}
          />
        </Flex>
      </FormControl>

      <Heading as="h2">Part Search - Enable Fixed Fields</Heading>

      <Flex gap={3} flexDirection="row">
        {objectEntriesTyped(PART_SEARCH_COLUMNS_FIXED_NAMES).map(
          ([field, name]) => (
            <FormControl key={name}>
              <Flex gap={3} flexDirection="row">
                <FormLabel htmlFor={`partSearchField_${field}`}>
                  {name}
                </FormLabel>
                <Switch
                  {...form.register(`partSearchField_${field}_enabled`)}
                  aria-label={`Enable ${name} search`}
                />
              </Flex>
            </FormControl>
          ),
        )}
      </Flex>

      <Heading as="h2">Part Search - Enable & Name User Fields</Heading>

      {PART_SEARCH_COLUMNS_CUSTOM_NAMES.map((name) => {
        return (
          <FormControl
            isInvalid={!!form.formState.errors[`partSearchField_${name}_name`]}
            flexDirection="row"
          >
            <Flex gap={3} flexDirection="row">
              <FormLabel htmlFor={`partSearchField_${name}`}>{name}</FormLabel>

              <Switch
                {...form.register(`partSearchField_${name}_enabled`)}
                aria-label={`Enable ${name} search`}
              />
              <Input {...form.register(`partSearchField_${name}_name`)} />

              <ErrorMessage
                name="partInsightsVisible"
                render={({ message }) => (
                  <FormErrorMessage>{message}</FormErrorMessage>
                )}
              />
            </Flex>
          </FormControl>
        );
      })}
    </Flex>
  );
};
